import {checkIsFirefox} from "helpers"
import {useLayoutEffect, useRef, useState} from "react"

export const useSaveScroll = (tableRef) => {
    const savedScrollPosition = useRef(0)
    const [checkScrollPosition, setCheckScrollPosition] = useState(false)
    const isFirefox = checkIsFirefox()

    useLayoutEffect(() => {
        if (tableRef && tableRef.current && savedScrollPosition.current !== 0) {
            if (isFirefox) {
                tableRef.current.scrollTop = savedScrollPosition.current
            } else {
                const container = tableRef.current._container
                if (container) {
                    container.scrollTop = savedScrollPosition.current
                }
            }
            savedScrollPosition.current = 0
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkScrollPosition])

    const handleActionRow = () => {
        if (tableRef?.current) {
            if (isFirefox) {
                savedScrollPosition.current = tableRef.current.scrollTop
            } else {
                const container = tableRef.current._container
                if (container) {
                    savedScrollPosition.current = container.scrollTop
                }
            }
        }
        setCheckScrollPosition((prev) => !prev)
    }

    return {handleActionRow}
}
